<template>
  <div>
    <!-- Card -->
    <b-card class="chatter-list">

      <!-- Card header -->
      <template #header>
        <div class="row align-items-center">
          <div class="col-xs">
            <h3> Files </h3>
          </div>
          <div class="col-4">
            <img src="../../../assets/images/reset_button.png" alt="reset-button" @click="refreshFileList"
              class="btn-reset-img" title="Reset Button" style="cursor:pointer;">
          </div>
        </div>
      </template>
      <!-- /Card header -->

      <!-- Card body -->
      <template #default>
        <div style="position:relative">
          <!-- Spinner -->
          <loading :active="loading" :is-full-page="false" />
          <!-- /Spinner -->

          <!-- Filter -->
          <file-filter @reload="reloadFileList" :isRefreshed="refresh" />
          <!-- /Filter -->

          <!-- Table -->
          <div class="custom-table-container">
            <table class="table table-hover custom-table">
              <colgroup>
                <col v-for="column in columns" :key="column.name" :width="column.width" />
              </colgroup>

              <thead>
                <tr class="text-center table-dark">
                  <th v-for="column in columns" :key="column.name" @click="sort(column)" class="chat-list-header">
                    {{ column.name | formatColumnName }}
                    <b-icon-triangle-fill v-if="column.sort === 'ASC'" font-scale="0.75" />
                    <b-icon-triangle-fill flip-v v-else-if="column.sort === 'DESC'" font-scale="0.75" />
                  </th>
                </tr>
              </thead>

              <!-- TODO 파일 목록도 Vuex에 저장해야하는지 고민 필요  -->
              <tbody v-if="files.length !== 0">
                <tr v-for="file in files" style="cursor: pointer;" :style="rowColor(file)" :class="substatus(file)">

                  <!-- File Name -->

                  <td class="align-middle">
                    <b-form-row selectable @click="downloadFile(file)" style="cursor:pointer;">
                      {{ file.filename }}
                    </b-form-row>
                  </td>
                  <!-- /File Name -->

                  <!-- File Size -->
                  <td class="text-center align-middle" @click="showChatDetail(file.chatId)">
                    <!-- TODO  -->
                    <span style="white-space: wrap">{{ file.fileSize | formatFileSize }}</span>
                    <!-- {{ formatProject(chat.projectId) }} -->
                  </td>
                  <!-- /File Size -->

                  <!-- Description -->
                  <td class="align-middle" @click="showChatDetail(file.chatId)">
                    <span style="white-space: wrap">{{ file.description }}</span>
                  </td>
                  <!-- /Description -->

                  <!-- Chat ID -->
                  <td class="text-center align-middle" @click="showChatDetail(file.chatId)">
                    <span class="title-text">{{ file.chatId }}</span>
                  </td>
                  <!-- /Chat ID -->

                  <!-- Project Name -->
                  <td class="text-center align-middle" @click="showChatDetail(file.chatId)">
                    <span style="white-space: wrap">{{ file.projectName }}</span>
                  </td>
                  <!-- /Project Name -->

                  <td class="text-center align-middle" @click="showChatDetail(file.chatId)">
                    <span class="status-tag" :class="getStatusTagClass(file.status)">{{ file.status | formatStatus
                    }}</span>
                  </td>


                  <!-- Chat Title -->
                  <td class="align-middle" @click="showChatDetail(file.chatId)">
                    <span style="white-space: wrap">{{ file.title }}</span>
                  </td>
                  <!-- /Chat Title -->

                  <!-- File Creation Date -->
                  <td class="text-center align-middle" @click="showChatDetail(file.chatId)">
                    <span style="white-space: wrap">{{ file.creationDate | formatCreationDate }}</span>
                  </td>
                  <!-- /File Creation Date -->
                </tr>
              </tbody>

              <tbody v-else>
                <tr>
                  <td colspan="11" style="text-align:center">결과가 없습니다.
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
          <!-- Table -->

          <!-- See More button -->
          <div class="btn-more-area">
            <button class="btn btn-view-more" @click="seeMore" :disabled="files.length >= total || total < pageLimit + 1">
              <span class="icon"><see-more-icon /></span>
              <span style="font-weight: 700;">See More&nbsp;</span>
              <span>({{ files.length }}/{{ total }})</span>
            </button>
          </div>
          <!-- See More button -->
        </div>
      </template>
      <!-- Card body -->
    </b-card>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import FileFilter from './FileFilter.vue';
import RefreshIcon from "@/components/chatter/icons/RefreshIcon.vue";
import SeeMoreIcon from "@/components/chatter/icons/SeeMoreIcon.vue";
import moment from 'moment';
import 'moment/locale/ko';

export default {
  name: "ChatterFileList",
  components: {
    Loading,
    FileFilter,
    RefreshIcon,
    SeeMoreIcon
  },
  computed: {
    files() {
      var files = this.$store.getters['chatterFiles/files'];

      //status bar 활성화된 경우(pageLimit 만큼 chat load)
      if (this.occupied) {
        return files.slice(0, this.pageLimit * this.$store.getters['chatterFiles/filter'].page);
      }
      return files;
    },
    total() {
      return this.$store.getters['chatterFiles/total'];
    },
    filter() {
      return this.$store.getters['chatterFiles/filter'];
    },
    options() {
      return this.$store.getters['chatter/options'];
    },
    occupied() {
      return this.$store.getters['chatterFiles/occupied'];
    },
    filterOccupied() {
      return this.$store.getters['chatterFiles/filterOccupied'];
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    userId() {
      return this.currentUser.caller;
    },
  },
  data() {
    return {
      loading: false,
      columns: [
        { name: 'File Name', sort: '', width: "27%" },
        { name: 'Size', sort: '', width: "5%" },
        { name: 'Description', sort: '', width: "20%" },
        { name: 'ID', sort: '', width: "5%" },
        { name: 'Project', sort: '', width: "7%" },
        { name: 'Status', sort: '', width: "8%" },
        { name: 'Title', sort: '', width: "20%" },
        { name: 'Upload Date', sort: '', width: "16%" },
      ],
      chattererOptions: [],
      sortedColumns: [],
      pageLimit: 10,
      //searchOptionsLabel: project > status > status-detail 형태
      searchOptionsLabel: "",
      refresh: false,
      refreshButtonName: "Refresh",
      isStatusBarClicked: false,
    }
  },
  created() {
    /* searchOptionsLabel(검색조건) 생성 로직: 검색 조건 걸고-> Detail 조회-> Close 후에도 라벨이 남아있기 위함*/
    // StatusBar 또는 Filter Label 만드는 함수 호출
    if (this.occupied) {
      this.getStatubBarSearchOptionsLabel();
    }
    if (this.filterOccupied) {
      this.getFilterSearchOptionsLabel();
    }
    /* searchOptionsLabel(검색조건) 생성 로직 */

    if (!this.files.length > 0) {
      this.retrieveFileList();
    }
  },
  methods: {
    async retrieveFileList() {
      // If Chatter Status Table has already occupied the list, return
      // For details, refer to Chatter Vuex (chatter.module.js)
      if (this.occupied) {
        this.getStatubBarSearchOptionsLabel();
        return;
      }
      try {
        this.loading = true;
        if (this.filterOccupied) {
          this.getFilterSearchOptionsLabel();
        }

        // Fetch chats
        let response = await axios.get('/chatter/retrieveFileList',

          {
            params: this.filter,
            headers: {
              Authorization: accessToken(),
              Accept: 'application/json'
            }
          }
        );

        // Commit the newly fetched chatters to Vuex
        response.data.list.forEach(item => item.isExpanded = false);
        this.$store.commit('chatterFiles/setFiles', response.data.list);

        // Set the total number of chatters in Vuex
        this.$store.commit('chatterFiles/setTotal', response.data.total);

        //refresh 값 초기화(자식에게 보내고 나면 초기화)=> Search Detail 창 닫힘, 작성중인 query 초기화
        this.refresh = false;

      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    refreshFileList() {
      this.$store.commit('chatterFiles/setOccupied', false);
      this.$store.commit('chatterFiles/setFilterOccupied', false)
      this.$store.commit('chatterFiles/setTotal', 0);
      this.$store.commit('chatterFiles/resetFilter');
      this.refresh = true;

      //Filter 및 Recent 버튼 활성화
      //this.isStatusBarClicked=false;
      this.retrieveFileList();
      //refresh 버튼 라벨 변경
      //this.refreshButtonName='Refresh';
    },
    reloadFileList() {
      this.$store.commit('chatterFiles/setTotal', 0);
      this.$store.commit('chatterFiles/setPage', 1);
      this.retrieveFileList();
    },
    seeMore() {
      //status bar 활성화
      if (this.occupied) {
        this.$store.commit('chatterFiles/incrementPage');
        //chat list 추가
        this.chats;
      }
      //filter 활성화
      else {
        this.$store.commit('chatterFiles/incrementPage');
        this.retrieveFileList();
      }

    },
    sort(column) {
      // Switch sorting order
      column.sort = ({
        '': 'ASC',
        ASC: 'DESC',
        DESC: ''
      })[column.sort];

      // Commit sorting orders
      this.$store.commit('chatterFiles/setSort', this.columns)

      // Reload chatter list
      this.reloadFileList();
    },
    substatus(chat) {
      let inactive = ['DONE', 'CLOSED', 'CANCELLED']
      if (inactive.includes(chat.status) || chat.dueDate === '-') {
        return 'unknown';
      } else if (chat.dueDate === this.today) {
        return 'dueOnToday';
      } else if (chat.dueDate < this.today) {
        return 'overdue';
      }
    },
    rowColor(chat) {
      return {
        color: ({
          dueOnToday: 'GoldenRed',
          overdue: 'Red',
          unknown: 'Black'
        })[this.substatus(chat)]
      }
    },

      showChatDetail(chatId) {
        this.$router.push({ name: "chatUpdate", params: { id: chatId } });
      },
      formatProject(value) {
        return this.options.projectOptions.filter(prj => prj.projectId === value)[0].name;
      },
      getStatusTagClass(status) {
        return status.replace('_', '-').toLowerCase();
      },
      //"" -> "All" 치환
      replaceStr(str){
        return str===undefined || str===''? 'All' : str;
      },
      async createFileURL(file) {
        console.log(file.downloadUrl);
        try {
          let data = null;
          let response = await axios.get(file.downloadUrl, {
            responseType: 'blob',
            headers: { Authorization: accessToken() }
          });
          data = response.data;
          return data ? URL.createObjectURL(data) : null;
        } catch (error) {
          await this.showError(error);
        }
      },
      // 파일 다운로드
      async downloadFile(file) {
        if(file.fileSize <= 0) {
          await this.showMessage("파일이 손상되었습니다.");
          return;
        }

      try {
        this.loading = true;
        await this.download(file);
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    async download(file) {
      const link = document.createElement('a');
      let url = await this.createFileURL(file);
      if (url) {
        link.href = url;
        link.download = file.filename;
        link.click();
      }
    },

    // expansion button 클릭 시 expansion 각각 작동하도록 함
    toggleChatExpansion(chat) {
      chat.isExpanded = !chat.isExpanded;
    },
    //StatusBar 조건에 맞는 라벨 생성
    getStatubBarSearchOptionsLabel() {
      this.getIsStatusBarClicked(true);
    },
    //StatusBar 조건에 맞는 라벨 생성
    getFilterSearchOptionsLabel() {
      this.setFilterSearchOptionsLabel();
    }
  },
  filters: {
    formatStatus(strStatus) {
      let arrStrStatus = strStatus.split("_");
      let result = '';
      for (let i in arrStrStatus) {
        let str = arrStrStatus[i]
        result = result + " " + str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
      return result
    },
    formatColumnName(name) {
      // 첫 글자를 대문자로 변경하고 중간에 대문자가 있는 경우 띄어쓰기 추가
      if (name.toUpperCase() === "ID") {
        // Exception. Id의 경우 모두 대문자로 변환하여 사용 - 20230614 박선익
        return name.toUpperCase()
      }
      return name.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase();
      });
    },
    // byte 단위의 파일 크기 MB로 변환
    formatFileSize(byte) {
      let fileSize = byte;
      // byte => kilobyte
      fileSize = Math.round(fileSize / 1024);

      if (fileSize < 1024) {
        return fileSize + 'KB'
      } else {
        return Math.round(fileSize / 1024) + 'MB';
      }
    },
    formatCreationDate(date) {
      return moment(date, 'YYYY-MM-DD hh:mm:ss').format('YYYY-MM-DD kk:mm')
    }
  },
}
</script>
<style>
td {
  vertical-align: middle;
}

.unread-label {
  position: absolute;
  top: 30%;
  left: 40%;
  transform: translate(-50%, -50%) rotate(-15deg);
  color: red;
  opacity: 0.9;
  font-size: 0.4em;
}

.down-arrow-icon {
  transform: translate(-50%, -50%) rotate(180deg);
  margin-left: 1em;
}

.chat-list-header {
  user-select: none;
  /* 드래그 불가능 */
  cursor: pointer;
  /* 포커스 시 커서를 손가락 모양으로 설정 */
}

.tooltip .tooltip-inner {
  max-width: 1000px !important;
  white-space: pre-wrap !important;
  text-align: start;
}

.popover {
  max-width: 1000px !important;
}

#export .modal-dialog {
  padding: 0;
}

#export .modal-body {
  padding: 0;
}

/* excel export 팝업 */
.popup-export.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.popup-export .modal-content {
  border-radius: 20px;
}

.popup-export .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

.popup-export .modal-title {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-header .close {
  width: 30px;
  height: 30px;
  margin: 0;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.popup-export#export .modal-body {
  padding: 1.041vw 2.666rem;
}

.popup-export label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-body .custom-select {
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.popup-export .btn-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
  padding: 2.604vw 0 1.562vw;
}

.popup-export .btn-wrap .btn {
  border-color: transparent;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.popup-export .btn-wrap .btn-primary.small {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
}

.popup-export .btn-wrap .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-primary.disabled,
.popup-export .btn-wrap .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-secondary.small {
  width: 148px;
  height: 40px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

.popup-export .btn-wrap .btn-secondary:hover {
  background-color: #565662;
}

.popup-export .btn-wrap .btn-secondary.disabled,
.popup-export .btn-wrap .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}
</style>
  
<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

/* button */
.btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn:focus {
  box-shadow: none;
}

.btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

.btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-primary.small {
  width: 148px;
  height: 40px;
}

.btn-export {
  width: 70px;
  height: 40px;
  background-color: #168D4C;
  color: #fff;
  border-color: transparent;
}

.btn-export:hover {
  background-color: #006F2E;
  border-color: transparent;
}

.btn-export.disabled,
.btn-export:disabled {
  color: #62796D;
  background-color: #759483;
}

.btn.btn-line {
  position: relative;
  width: 135px;
  height: 60px;
  border: 1px solid #C4C4CD;
  background-color: transparent;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: inherit;
}

.btn.btn-line:hover {
  color: #2E2E38;
  border: 1px solid #2E2E38;
  background-color: transparent;
}

.btn.btn-line.disabled,
.btn.btn-line:disabled {
  border: 1px solid #DDDDE3;
  background-color: transparent;
}

.btn.btn-line.small {
  height: 40px;
  text-align: center;
}

.btn-refresh {
  height: auto;
  padding: 0;
}

/* 공통요소 */
.select-custom-scrollbar::-webkit-scrollbar {
  width: 12px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #E7E7EE;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

/* card 영역 */
.card {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  font-family: 'NanumGothic';
}

.card>.card-body {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
  /* padding-bottom: max(2.666rem, 2.0833vw); */
}

/* today work 영역 */
.card.today-work-wrap .card-body {
  padding-bottom: max(2rem, 1.5625vw);
}

.work-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 1.333rem;
}

.work-wrap .work-progress .title-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.533rem;
}

.work-wrap .work-progress .title-wrap .title {
  font-size: 18px;
  font-weight: 700;
}

.work-wrap .work-progress .title-wrap .rate {
  font-size: 14px;
  font-weight: 400;
  color: #06F;
}

.work-wrap .work-progress .title-wrap .rate span:first-child {
  font-weight: 700;
}

.work-wrap .work-progress .progress-bar {
  width: 17.3333rem;
  height: 26px;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 255, 0.10);
  background-color: #D8E7FF;
}

.work-wrap .work-progress .progress-bar .bar {
  height: 100%;
  background-color: #06F;
}

.work-wrap .work-progress {
  flex-grow: 0;
  flex-shrink: 1;
  margin-right: 60px;
}

.work-wrap .status-list-wrap {
  flex-shrink: 1;
  flex-grow: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.333rem, auto));
  gap: 0.4rem;
  padding: 0;
  margin: 0;
  list-style: none;
}

.work-wrap .status-list-wrap .status-list {
  /* min-width: 140px; */
  height: 40px;
}

.work-wrap .status-list-wrap .status-list .status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 10px;
  min-width: 100%;
  height: 100%;
  padding: 0 0.466rem 0 0.8rem;
  border-radius: 34px;
  border: 1px solid #DDDDE3;
  background-color: #fff;
  font-size: 14px;
  color: #2E2E38;
}

.work-wrap .status-list-wrap .status-list:hover .status-item {
  border: 1px solid #2E2E38;
}

.work-wrap .status-list-wrap .status-list .status-item span {
  display: inline-block;
}

.work-wrap .status-list-wrap .status-list.bg-gray .status-item {
  border: 1px solid transparent;
  background-color: #E7E7EE;
}

.work-wrap .status-list-wrap .status-list.bg-gray:hover .status-item {
  background-color: #D4D4DC;
}

.work-wrap .status-list-wrap .status-list.bg-bk .status-item {
  border: 1px solid transparent;
  background-color: #40404B;
  color: #fff;
}

.work-wrap .status-list-wrap .status-list.bg-bk:hover .status-item {
  background-color: #1B1B1B;
}

.work-wrap .status-list-wrap .status-item .status {
  font-weight: 500;
  line-height: 150%;
}

.work-wrap .status-list-wrap .status-item .num {
  height: 26px;
  padding: 0 0.5rem;
  border-radius: 30px;
  background-color: #fff;
  color: #2E2E38;
  text-align: center;
  line-height: 26px;
  font-weight: 700;
  font-size: 14px;
}

.work-wrap .status-list-wrap .status-list.bg-bk .status-item .num {
  background-color: transparent;
  color: #fff;
}

/* chatter list 영역 */
.card.chatter-list {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.card.chatter-list .card-header {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
  padding-bottom: 1erm;
  border-radius: 30px 30px 0 0;
  border-bottom: none;
}

.card.chatter-list .card-header>div {
  flex-wrap: wrap;
  /* gap: 2rem; */
}

.card.chatter-list .card-header .title-wrap {
  display: flex;
  gap: 0 1.333rem;
}

.card.chatter-list .card-header h3 {
  display: flex;
  align-items: center;
  gap: 0 1.333rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

.card.chatter-list .card-header h3>span {
  white-space: nowrap;
}

.card.chatter-list .card-header .btn-wrap {
  display: flex;
  gap: 0 2rem;
}

.card.chatter-list .card-header .btn-wrap .btn-group-area {
  position: relative;
  display: flex;
  gap: 0 0.666rem;
}

.card.chatter-list .card-header .btn-wrap .btn-group-area::after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  right: -1rem;
  transform: translateY(-50%);
  width: 1px;
  height: calc(100% - 1.066rem);
  background-color: #DDDDE3;
}

/* my chatter list table 영역 */
.custom-table-container {
  margin-top: 1rem;
  padding: 0.666rem;
  border-radius: 20px;
  background-color: #F6F6FA;
}

.table.custom-table {
  margin-bottom: 0;
}

.table.custom-table tr {
  color: #2E2E38;
  background-color: #FFF;
}

.table.custom-table tr:hover {
  background-color: #FAFAFA;
}

.table.custom-table thead th,
.table-bordered.custom-table th {
  height: 70px;
  padding-top: calc(0.75rem - 0.666rem);
  background-color: #F6F6FA;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #C4C4CD;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  vertical-align: middle;
  white-space: nowrap;
}

.table.custom-table td {
  min-height: 80px;
  padding: 1.333rem 0.666vw;
  border-top: 1px solid #E7E7EE;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  vertical-align: middle;
}

.table.custom-table td .title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table.custom-table td .title-wrap .title-container {
  flex-grow: 1;
}

.table.custom-table td .title-wrap .title-text {
  padding-left: 2.067rem;
  font-weight: 700 !important;
}

.table.custom-table td .title-wrap .chatter-hierarchy {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
  padding-left: 0.533rem;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn-close-collapse {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 16px;
  height: 10px;
  border-radius: 20px;
  background-color: #747480;
}

.btn-close-collapse span {
  display: block;
  width: 6px;
  height: 1.5px;
  background-color: #FFFFFF;
}

.btn-subordinate {
  border: none;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  width: 36px;
  height: 36px;
  background-color: transparent;
  padding: 0;
}

.icon-arrow-subordinate {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  background-color: transparent;
  padding: 0;
}

.btn-superior {
  display: inline-block;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  background-color: transparent;
}

.table.custom-table tr:last-child td:first-child {
  border-radius: 0 0 0 10px;
}

.table.custom-table tr:last-child td:last-child {
  border-radius: 0 0 10px 0;
}

.table.custom-table .status-tag {
  display: inline-block;
  max-width: 100px;
  width: 100%;
  height: 29px;
  padding: 4px 6px;
  border-radius: 38px;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  white-space: nowrap
}

.table.custom-table .status-tag.in-progress {
  background-color: #F5ECD6;
  color: #FF5C00;
}

.table.custom-table .overdue .status-tag.in-progress {
  background-color: #F5D6D6;
  color: #F00;
}

.table.custom-table .status-tag.to-do {
  background-color: #F6F6FA;
  color: #2E2E38;
}

.table.custom-table .status-tag.done {
  background-color: #CFDDFF;
  color: #1755CC;
}

.table.custom-table .status-tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}

.table.custom-table .status-tag.cancelled {
  background-color: #E4E4EA;
  color: rgba(116, 116, 128, 0.70);
}

.btn.updated {
  padding: 0;
  background-color: transparent;
  border-radius: 0;
  color: #1755CC;
  font-size: 12px;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  opacity: 1;
}

.level-circle {
  display: inline-block;
  font-size: 6px;
  margin-left: 0.533rem;
  transform: translateY(-1.5px);
}

.unread-label {
  position: relative;
  top: unset;
  left: unset;
  transform: none;
  color: #F00;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  opacity: 1;
}

.assignee-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.729vw;
  width: 100%;
  white-space: nowrap;
}

.assignee-wrap .user-profile {
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  display: inline-block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
}

.assignee-wrap .user-profile img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  object-fit: cover;
}

.assignee-wrap .assignee-name {
  width: calc(100% - 40px - 0.729vw);
  max-width: 98px;
}

.btn-more-area {
  display: flex;
  justify-content: center;
  margin-top: 2.666rem;
}

.btn-more-area .btn-view-more {
  display: inline-block;
  width: auto;
  height: auto;
  margin: 0;
  padding: 1.3rem 3.3rem 1.3rem 3.033rem;
  border-radius: 60px;
  background-color: #E7E7EE;
}

.btn-more-area .btn-view-more .icon {
  margin-top: -3px;
  margin-right: 0.533rem;
}

.btn-more-area .btn-view-more span {
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  line-height: 150%;
}

.btn-more-area .btn-view-more:hover {
  background-color: #C4C4CD;
}

.btn-reset-img {
  width: 25px;
  height: 27px;
  margin: 0 10px 0 10px;

}

.btn-recent-img {
  width: 30px;
  height: 30px;
}
</style>